var render = function render(){var _vm=this,_c=_vm._self._c;return _c('pre',_vm._b({},'pre',_vm.$attrs,false),[_vm._v(_vm._s(_vm.displayValue))])
}
var staticRenderFns = []

export { render, staticRenderFns }